import classes from "./FeatureFlow.module.css";

import arrow1 from "./img/Vector-1.png";
import arrow2 from "./img/Vector-2.png";
import arrow3 from "./img/Vector-3.png";

const arrows = [arrow1, arrow2, arrow3];

export default function FeatureFlow({
  heading = "",
  highlights = [],
  paragraph = "",
  steps = [],
}) {
  const renderHeading = () => {
    if (!heading) {
      return null;
    }

    if (!Array.isArray(highlights) || highlights.length === 0) {
      return heading;
    }

    const escapedHighlights = highlights
      .filter(Boolean)
      .sort((a, b) => b.length - a.length)
      .map((text) => text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));

    if (escapedHighlights.length === 0) {
      return heading;
    }

    const pattern = new RegExp(`(${escapedHighlights.join("|")})`, "gi");

    return heading.split(pattern).map((part, index) => {
      const isHighlight = highlights.some(
        (text) => text.toLowerCase() === part.toLowerCase(),
      );

      return isHighlight ? (
        <span className={classes.highlight} key={index}>
          {part}
        </span>
      ) : (
        <span key={index}>{part}</span>
      );
    });
  };

  return (
    <section className={classes.section}>
      <div className={classes.shell}>
        {(heading || paragraph) && (
          <header className={classes.header}>
            {heading && (
              <h2 className={classes.heading}>
                {renderHeading()}
              </h2>
            )}

            {paragraph && (
              <p className={classes.paragraph}>
                {paragraph}
              </p>
            )}
          </header>
        )}

        {steps.length > 0 && (
          <div className={classes.flowTrack}>
            {steps.map((step, index) => {
              const isTop = step.align === "top";
              const arrow = arrows[index];

              const copy = (
                <div className={classes.copy}>
                  {step.title && (
                    <h3 className={classes.stepTitle}>{step.title}</h3>
                  )}

                  {step.description && (
                    <p className={classes.stepText}>{step.description}</p>
                  )}

                  {step.link?.url && step.link?.label && (
                    <a
                      href={step.link.url}
                      className={classes.link}
                      target={step.link.target || undefined}
                      rel={
                        step.link.target === "_blank"
                          ? "noopener noreferrer"
                          : undefined
                      }
                    >
                      {step.link.label}
                    </a>
                  )}
                </div>
              );

              const node = step.icon ? (
                <div className={classes.node}>
                  <span className={classes.nodeIcon} aria-hidden="true">
                    {step.icon}
                  </span>
                </div>
              ) : null;

              return (
                <div key={step.title || index} className={classes.flowCell}>
                  <article
                    className={`${classes.stepCard} ${
                      step.featured ? classes.featured : ""
                    } ${isTop ? classes.alignTop : classes.alignBottom}`}
                  >
                    {isTop ? (
                      <>
                        {copy}
                        {node}
                      </>
                    ) : (
                      <>
                        {node}
                        {copy}
                      </>
                    )}
                  </article>

                  {arrow && index < steps.length - 1 && (
                    <div className={classes.connector} aria-hidden="true">
                      <img
                        src={arrow}
                        alt=""
                        className={classes.connectorImage}
                      />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}
